import axios from 'axios';

const API = '';

export const listarFornecedores = (params) =>
  axios.get(`/fornecedores`, { params });

export const criarFornecedor = (data) =>
  axios.post(`/fornecedores`, data);
